import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NotificacaoService } from 'src/app/services/notificacao.service';

@Component({
  selector: 'app-enviar-email-modal',
  templateUrl: './enviar-email-modal.component.html',
  styleUrls: ['./enviar-email-modal.component.scss']
})
export class EnviarEmailModalComponent implements OnInit {
  public config: PerfectScrollbarConfigInterface = {};
  public email: any = {
    para: '',
    assunto: '',
    mensagem: ''
  };

  constructor(
    public dialogRef: MatDialogRef<EnviarEmailModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificacaoService: NotificacaoService
  ) {
    if (data) {
      this.email.para = data.para || '';
      this.email.assunto = data.assunto || '';
      this.email.mensagem = data.mensagem || '';
    }
  }

  ngOnInit() {
  }

  enviar() {
    if (!this.email.para || !this.email.assunto || !this.email.mensagem) {
      this.notificacaoService.erro('Todos os campos são obrigatórios.');
      return;
    }

    this.dialogRef.close(this.email);
  }

  fechar() {
    this.dialogRef.close();
  }
}
